import { styled } from '@linaria/react'

export const TextBlockAccountInfoSC = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`
